import React from 'react';

const DragIndicatorIcon = (props) => {
	const { className } = props;
	return (
		<i className={`material-icons drag-indicator${className ? " " + className : ""}`}>drag_indicator</i>
	)
}

export default DragIndicatorIcon;